import { Injectable } from '@angular/core';
import { WorkoutService } from '../../../services';
import { Actions, Effect, Observable, Action, ofType, Types, switchMap, map, Fields, GetWorkoutTypes, GetWorkoutIntervalOptions } from './workouts.model';
import { StorageUtil } from '../../../store';
import { GetWorkoutPlans } from './workouts.model';
import * as lodash from 'lodash';

@Injectable() export class WorkoutsEffects {

  constructor(
    private ws: WorkoutService,
    private as: Actions
  ) { }

  @Effect() getWorkoutPlans: Observable<Action> = this.as.pipe(
    ofType(Types.GetWorkoutPlans),
    switchMap((_: GetWorkoutPlans) => this.ws.getWorkoutPlans(StorageUtil.teamId)),
    map((res) => (
      {
        type: Types.UpdateState,
        payload: {
          [Fields.WorkoutPlans]: res.map(p => (p.hash = p.name.toLowerCase().split(' ').join('-'), p))
        }
      }
    ))
  );

  @Effect() getWorkoutTypes: Observable<Action> = this.as.pipe(
    ofType(Types.GetWorkoutTypes),
    // switchMap((_: GetWorkoutTypes) => this.ws.getWorkoutTypes()),
    switchMap((_: GetWorkoutTypes) => this.ws.getWorkoutCategories()),
    map((res) => (
      {
        type: Types.UpdateState,
        payload: {
          [Fields.WorkoutTypes]: res
        }
      }
    ))
  );

  @Effect() getWorkoutIntervalOptions: Observable<Action> = this.as.pipe(
    ofType(Types.GetWorkoutIntervalOptions),
    switchMap((_: GetWorkoutIntervalOptions) => this.ws.getWorkoutIntervalOptions()),
    map((res) => (
      {
        type: Types.UpdateState,
        payload: {
          [Fields.WorkoutIntervalOptions]: res
        }
      }
    ))
  );

}



// WEBPACK FOOTER //
// ./src/app/pages/team-development-calendar/store/workouts.effects.ts